
export const FETCH_INCREMENT_REQUESTED = 'auth/FETCH_INCREMENT_REQUESTED'
export const FETCH_INCREMENT_SUCCEED = 'auth/FETCH_INCREMENT_SUCCEED'
export const FETCH_DECREMENT_REQUESTED = 'auth/FETCH_DECREMENT_REQUESTED'
export const FETCH_DECREMENT_SUCCEED = 'auth/FETCH_DECREMENT_SUCCEED'

export const FETCH_LOGIN_REQUESTED = 'auth/FETCH_LOGIN_REQUESTED'
export const FETCH_LOGIN_SUCCEED = 'auth/FETCH_LOGIN_SUCCEED'
export const FETCH_LOGIN_FAIL = 'auth/FETCH_LOGIN_FAIL'

export const LOGOUT = 'auth/LOGOUT'



// WEBPACK FOOTER //
// ./src/store/auth/actionTypes.js